module.exports = __webpack_public_path__ + "img/Left Wing.a6dd52fe.png";